import { __awaiter } from "tslib";
import { BaseService } from "@/servicesTs/base";
export class MedicalBenefitService extends BaseService() {
    static get entity() {
        return "medical_benefit";
    }
    static get responseName() {
        return "medical_benefit";
    }
    //ESTAN REPETIDOS POR QUE ES UN MERGE... UNO DEBE MORIR EVENTUALMENTE
    static findByNodeId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_node_id/${id}`,
            });
        });
    }
    static getByNode(node_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_node_id/${node_id}`,
            });
        });
    }
    /**
     *
     * @param data.node_id
     * @param data.service_node_id
     * @param data.state 'active' | 'passive'
     * @param data.paginate true tiene paginación
     */
    static getFilter(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `filter`,
                data: data,
            });
        });
    }
}
